var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6706 16.1012C14.6681 16.0678 14.6668 16.034 14.6668 16V5.33333C14.6668 4.59733 15.2628 4 16.0002 4C16.7375 4 17.3335 4.59733 17.3335 5.33333V15.9998L20.5335 13.6C21.1228 13.156 21.9588 13.2773 22.4002 13.8667C22.8428 14.456 22.7228 15.292 22.1335 15.7333L16.8002 19.7333C16.5642 19.9107 16.2815 20 16.0002 20C15.7322 20 15.4642 19.9187 15.2335 19.7573L9.90016 16.0053C9.2975 15.5813 9.15216 14.7493 9.57616 14.148C10.0002 13.5453 10.8308 13.4 11.4335 13.824L14.6706 16.1012ZM8.00016 22.6667V24H24.0002V22.6667C24.0002 21.9333 24.6002 21.3333 25.3335 21.3333C26.0668 21.3333 26.6668 21.9333 26.6668 22.6667V25.3333C26.6668 26.0667 26.0668 26.6667 25.3335 26.6667H6.66683C5.9335 26.6667 5.3335 26.0667 5.3335 25.3333V22.6667C5.3335 21.9333 5.9335 21.3333 6.66683 21.3333C7.40016 21.3333 8.00016 21.9333 8.00016 22.6667Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 22,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6706 16.1012C14.6681 16.0678 14.6668 16.034 14.6668 16V5.33333C14.6668 4.59733 15.2628 4 16.0002 4C16.7375 4 17.3335 4.59733 17.3335 5.33333V15.9998L20.5335 13.6C21.1228 13.156 21.9588 13.2773 22.4002 13.8667C22.8428 14.456 22.7228 15.292 22.1335 15.7333L16.8002 19.7333C16.5642 19.9107 16.2815 20 16.0002 20C15.7322 20 15.4642 19.9187 15.2335 19.7573L9.90016 16.0053C9.2975 15.5813 9.15216 14.7493 9.57616 14.148C10.0002 13.5453 10.8308 13.4 11.4335 13.824L14.6706 16.1012ZM8.00016 22.6667V24H24.0002V22.6667C24.0002 21.9333 24.6002 21.3333 25.3335 21.3333C26.0668 21.3333 26.6668 21.9333 26.6668 22.6667V25.3333C26.6668 26.0667 26.0668 26.6667 25.3335 26.6667H6.66683C5.9335 26.6667 5.3335 26.0667 5.3335 25.3333V22.6667C5.3335 21.9333 5.9335 21.3333 6.66683 21.3333C7.40016 21.3333 8.00016 21.9333 8.00016 22.6667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_163)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.009467c714ec4477f40434fe7b91cdc4.svg";
export { ForwardRef as ReactComponent };